import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import {
  IMembershipVMSCategoryResponse,
  IMembershipVMSCategoryResponseData,
} from "@/api_framework/api_modals/Membership";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});

export const useMembershipVMSCategoryAPI = () => {
  const [membershipCategory, setMembershipCategory] = useState<IMembershipVMSCategoryResponseData[]>([]);
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(MEMBERSHIP_MODULE?.MEMBERSHIP_VMS_CATEGORY?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMembershipVMSCategoryResponse>) => {
          if (res.data.status === true) {
            setMembershipCategory(res.data.data);
          } else {
            setMembershipCategory([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setMembershipCategory([]);
        });
    } catch (error) {
      setMembershipCategory([]);
      if (axios.isAxiosError(error)) {
        captureError(error);
      }
    }
  }, []);

  return { execute, membershipCategory };
};
